module.exports = __webpack_public_path__ + "static/media/player_badge.bea3e5c0.svg";